import React, { ReactElement } from 'react';
import { trackContactRecommendations } from '../../tracking';
import { ContactRecommendationsWithFragment } from '../../components';

type AgentRecommendationsProps = {
  agentIdV2: string;
  agencyId: number;
};

export const AgentRecommendations: React.FC<AgentRecommendationsProps> = ({
  agentIdV2,
  agencyId,
}: AgentRecommendationsProps): ReactElement => (
  <ContactRecommendationsWithFragment
    agentIdV2={agentIdV2}
    agencyId={agencyId}
    onPageRendered={trackContactRecommendations.trackContactPageRendered}
    onVendorRecoViewAll={trackContactRecommendations.trackContactViewAll}
    onVendorRecoRendered={trackContactRecommendations.trackContactRendered}
    onVendorRecoImpression={trackContactRecommendations.trackContactImpression}
    onVendorRecoModalViewMore={
      trackContactRecommendations.trackContactModalViewMore
    }
    onVendorRecoModalPrev={
      trackContactRecommendations.trackContactModalPrevious
    }
    onVendorRecoModalNext={trackContactRecommendations.trackContactModalNext}
    onVendorRecoShowMore={trackContactRecommendations.trackContactShowMore}
  />
);

export default AgentRecommendations;
